import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

// ----------------------------------------------------------------------------

function _TableInput(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------
    const { value, onChange, onDoneEditing, useTextArea } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return useTextArea ? (
        <textarea
            value={value}
            onChange={onChange}
            className={`${props.className} area`}
            onBlur={onDoneEditing}
        />
    ) : (
        <input
            className={`${props.className} dynamic-input`}
            value={value}
            onChange={onChange}
            onBlur={onDoneEditing}
        />
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_TableInput.propTypes = {
    className: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onDoneEditing: PropTypes.func,
    useTextArea: PropTypes.bool,
}

_TableInput.defaultProps = {}

// ----------------------------------------------------------------------------

const TableInput = styled(_TableInput)`
    & {
        &.dynamic-input {
            outline: none;
            background: transparent;
            border-radius: 6px;
            padding: 5px;
            transition: all 200ms ease;
            width: fit-content;
            border: 1px solid transparent;
            font-size: 14px;
            min-width: 100px;
            width: ${(props) => `${props?.value?.length + 2}ch`};
            &:focus {
                border: 1px solid
                    ${({ theme }) => theme.colors.buttonBackground};
            }
        }
        &.area {
            height: 60px;
            width: 200px;
            outline: none;
            background: transparent;
            border-radius: 6px;
            padding: 5px;
            border: 1px solid transparent;
            &:focus {
                border: 1px solid
                    ${({ theme }) => theme.colors.buttonBackground};
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default TableInput
